module.exports = __webpack_public_path__ + "img/amber.3d63d720.jpg";